module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', _vm._l((_vm.columns), function(column) {
    return _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isVisibile(column)),
        expression: "isVisibile(column)"
      }],
      style: ({
        whiteSpace: column.isMultiLine ? 'normal' : 'nowrap'
      }),
      attrs: {
        "title": _vm.row[column.fieldName] !== -1 ? _vm.row[column.fieldName] : ''
      }
    }, [(column.isStatus) ? _c('span', [(column.fieldName === 'IsUSB' && _vm.row[column.fieldName]) ? _c('i', {
      staticClass: "icon fa fa-usb",
      attrs: {
        "title": "USB Client"
      }
    }) : (column.fieldName === 'IsUSB' && !_vm.row[column.fieldName]) ? _c('i', {
      staticClass: "icon fa fa-sitemap",
      attrs: {
        "title": "Network Client"
      }
    }) : _c('i', {
      staticClass: "fa fa-circle",
      style: ({
        color: _vm.getStatusColor(_vm.row[column.fieldName])
      })
    })]) : (column.isIcon) ? _c('span', {
      staticClass: "spanCenter"
    }, [_c('i', {
      class: [_vm.getIconClass(_vm.row[column.fieldName])],
      staticStyle: {
        "font-size": "20px"
      }
    })]) : (column.isLink) ? _c('span', [_c('router-link', {
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: column.route,
          params: {
            printerKey: _vm.row[column.param]
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.row[column.fieldName]) + "\n      ")])], 1) : (column.isBool) ? _c('span', {
      staticClass: "spanCenter"
    }, [(_vm.row[column.fieldName]) ? _c('i', {
      staticClass: "fa fa-check text-green"
    }) : _c('i', {
      staticClass: "fa fa-times text-red"
    })]) : (column.isActive) ? _c('span', {
      staticClass: "spanCenter",
      on: {
        "click": function($event) {
          return _vm.$emit('click', 'Activate', _vm.row)
        }
      }
    }, [(_vm.row[column.fieldName]) ? _c('i', {
      staticClass: "fa fa-toggle-on text-green"
    }) : _c('i', {
      staticClass: "fa fa-toggle-on text-red rotate180"
    })]) : (column.isLock) ? _c('span', {
      staticClass: "spanCenter",
      on: {
        "click": function($event) {
          return _vm.$emit('click', 'Lock', _vm.row)
        }
      }
    }, [(_vm.row[column.fieldName]) ? _c('i', {
      staticClass: "fa fa-lock text-red"
    }) : _c('i', {
      staticClass: "fa fa-unlock text-green"
    })]) : (column.isProgress) ? _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row[column.fieldName] >= 0),
        expression: "row[column.fieldName] >= 0"
      }]
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row[column.fieldName] >= 0),
        expression: "row[column.fieldName] >= 0"
      }],
      staticClass: "progress-group",
      staticStyle: {
        "width": "80px"
      }
    }, [_c('div', {
      staticClass: "progress sm",
      staticStyle: {
        "background-color": "#ccc",
        "height": "20px"
      }
    }, [_c('div', {
      class: ['progress-bar', column.fieldName],
      style: ({
        width: _vm.row[column.fieldName] + '%'
      })
    }, [_vm._v(_vm._s(_vm.row[column.fieldName]) + "%")])])])]) : (column.fieldName !== 'VueBottons') ? _c('span', [(false && _vm.row.IsNew && column.fieldName === 'MacAddress') ? _c('i', {
      staticClass: "fa fa-star text-yellow",
      attrs: {
        "title": "New Printer"
      }
    }) : _vm._e(), _vm._v(" "), (column.fieldName === 'ModelName' && _vm.row.CounterStatus === 'Error') ? _c('i', {
      staticClass: "fa fa-star text-red",
      attrs: {
        "title": "Wrong Counters!!"
      }
    }) : _vm._e(), _vm._v(" "), (column.fieldName === 'DeviceCode') ? _c('i', {
      staticClass: "fa fa-edit text-grey",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('click', column.fieldName, _vm.row)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      class: [column.className, (_vm.row.IsNew && column.fieldName === 'MacAddress') ? 'newLable' : ''],
      style: ({
        whiteSpace: column.isMultiLine ? 'normal' : 'nowrap'
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.$root.shortText(_vm.row[column.fieldName], column.length))
      }
    })]) : _c('div', {
      staticStyle: {
        "text-align": "right"
      }
    }, _vm._l((column.bottons), function(btn) {
      return _c('a', {
        staticClass: "btn-flat",
        staticStyle: {
          "margin-left": "10px",
          "font-size": "20px",
          "cursor": "pointer"
        },
        attrs: {
          "title": btn.label
        }
      }, [(btn.isLink && btn.name === 'InfoPrinter') ? _c('router-link', {
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: btn.route,
            params: {
              printerKey: _vm.row[btn.param]
            }
          }
        }
      }, [_c('i', {
        class: [_vm.getBtnClass(btn, column, _vm.row)],
        style: ({
          color: btn.color
        })
      })]) : (btn.isLink && btn.name === 'HistoryPrinter') ? _c('router-link', {
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: btn.route,
            params: {
              printerKey: _vm.row[btn.param]
            }
          }
        }
      }, [_c('i', {
        class: [_vm.getBtnClass(btn, column, _vm.row)],
        style: ({
          color: btn.color
        })
      })]) : (btn.isLink && btn.name === 'DealerInfo') ? _c('router-link', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.row[btn.param]),
          expression: "row[btn.param]"
        }],
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: btn.route,
            params: {
              dealerKey: _vm.row[btn.param]
            }
          }
        }
      }, [_c('i', {
        class: [_vm.getBtnClass(btn, column, _vm.row)],
        style: ({
          color: btn.color
        })
      })]) : _c('i', {
        class: [_vm.getBtnClass(btn, column, _vm.row)],
        style: ({
          color: btn.color
        }),
        on: {
          "click": function($event) {
            return _vm.$emit('click', btn.name, _vm.row)
          }
        }
      })], 1)
    }), 0)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d82a690!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table/TableRow.vue
// module id = 670
// module chunks = 0